import { PrimaryButton } from "@digipost/dds-buttons-react";
import * as Sentry from "@sentry/react";
import { PropsWithChildren } from "react";

import ErrorPage from "../ErrorPage";
import Header from "../header/Header";
import { logError } from "./serverlog";
import Translated from "./Translated";

const AppErrorBoundary: React.FC<PropsWithChildren> = ({ children }) => (
  <Sentry.ErrorBoundary
    onError={(error, _componentStack, sentryEventId) => {
      logError(error, { origin: "AppErrorBoundary", sentryEventId });
    }}
    fallback={
      <>
        <Header />
        <ErrorPage>
          <Translated textKey="error.app.try_again" />
          <PrimaryButton onClick={() => window.location.reload()}>
            <Translated textKey="generic.retry" />
          </PrimaryButton>
        </ErrorPage>
      </>
    }
  >
    {children}
  </Sentry.ErrorBoundary>
);

export default Sentry.withErrorBoundary(AppErrorBoundary, {});
